import axios from 'axios';

export const retentionCodeApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/stk-retention-code`,
    headers: {
        'Content-Type': 'application/json'
    }
})